import React, { Fragment } from 'react';
import { createRoot } from 'react-dom/client';
import { flare } from '@flareapp/js';

import MainSidebar from '../sidebar/MainSidebar';

$(() => {
    const container = document.getElementById('main-sidebar-container');
    const root = createRoot(container);
    root.render(
        <Fragment>
            <MainSidebar />
        </Fragment>,
    );

    // Only enable Flare in production, we don't want to waste your quota while you're developing:
    if (window._isProduction) {
        flare.light(window._flareKey);
    }
});
